<template>
  <div class="add-shop-contact-list">
    <v-modal
      animation="slide-up"
      :minWidth="computedMinWidth"
      :full="!screen.breakPoint.tabPort"
      v-model="showModal"
      handle-click-bg
    >
      <template v-slot:activator="{ on }">
        <slot name="activator" :on="on"></slot>
      </template>

      <template #header>
        {{ $t('components.Profile.addShop.contactList') }}
      </template>

      <div class="add-shop-contact-list__options-block">
        <div class="add-shop-contact-list__options-item" v-for="(item, index) of computedContactList" :key="index.toString() + '-' + item.id">
          <div>
            <v-input
              :placeholder="$t('components.Profile.addShop.contactListPopup.name')"
              :value="item.name"
              @input="(e) => onNameInput(index, e)"
              :error="localDataErrors[index] ? localDataErrors[index].name : null"
            ></v-input>
            <autocomplete
              :placeholder="$t('components.Profile.addShop.contactListPopup.messenger')"
              :value="item.type"
              :items="contactTypes"
              item-text="name"
              :value-field="'value'"
              @input="(e) => onTypeInput(index, e)"
              :error="localDataErrors[index] ? localDataErrors[index].type : null"
            ></autocomplete>
            <v-input
              :placeholder="$t('components.Profile.addShop.contactListPopup.phoneOrUsername')"
              :value="item.contact"
              @input="(e) => onContactInput(index, e)"
              :error="localDataErrors[index] ? localDataErrors[index].contact : null"
            ></v-input>
            <v-button
              color="error"
              :style="{width: screen.breakPoint.tabLand ? '2rem' : '100%'}"
              @click="removeItem(index)">
              <i class="icon-trash text--xx-large"></i>
            </v-button>
          </div>
        </div>
      </div>

      <div class="d-flex justify-center">
        <v-button size="large" outline rounded color="secondary" @click="addContact()">
          <span class="icon-plus text--xx-large"></span>
        </v-button>
      </div>

      <template #footer>
        <v-button width="full" @click="save()">{{ $t('components.DatePicker.footer') }}</v-button>
      </template>
    </v-modal>
  </div>
</template>

<script>
import vModal from '@/ui/modals/vModal'

import vButton from '@/ui/controls/vButton'
import vInput from '@/ui/controls/vInput'
import Autocomplete from '@/ui/controls/Autocomplete'

import screen from '@/mixins/screen'

export default {
  mixins: [screen],

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      showModal: false,
      localDataErrors: [],
      localData: []
    }
  },

  components: {
    vModal,
    vButton,
    vInput,
    Autocomplete
  },

  computed: {
    computedMinWidth () {
      if (this.screen.breakPoint.tabLand) {
        return '90rem'
      }

      if (this.screen.breakPoint.tabPort) {
        return '55rem'
      }

      return null
    },

    contactTypes () {
      return [
        {
          value: 'phone',
          name: this.$t('components.Profile.addShop.contactListPopup.phone')
        },
        {
          value: 'email',
          name: this.$t('components.Profile.addShop.contactListPopup.email')
        },
        {
          value: 'whatsapp',
          name: this.$t('components.Profile.addShop.contactListPopup.whatsup')
        },
        {
          value: 'telegram',
          name: this.$t('components.Profile.addShop.contactListPopup.telegram')
        },
        {
          value: 'viber',
          name: this.$t('components.Profile.addShop.contactListPopup.viber')
        },
        {
          value: 'skype',
          name: this.$t('components.Profile.addShop.contactListPopup.skype')
        }
      ]
    },

    computedContactList () {
      return this.localData
    }
  },

  methods: {
    validateContactList () {
      const out = []
      this.localData.forEach((row, index) => {
        out.push(null)

        const errObj = {}
        if (row.name === null || row.name === '' || typeof row.name === 'undefined') {
          errObj.name = this.$t('components.Profile.required')
        }

        if (row.type === null || row.type === '' || typeof row.type === 'undefined') {
          errObj.type = this.$t('components.Profile.required')
        }

        if (row.contact === null || row.contact === '' || typeof row.contact === 'undefined') {
          errObj.contact = this.$t('components.Profile.required')
        }

        if (errObj.name || errObj.type || errObj.contact) {
          out[index] = errObj
        }
      })

      let hasErrors = false
      out.forEach(e => {
        if (e) {
          hasErrors = true
        }
      })

      if (hasErrors) {
        this.localDataErrors = out
        this.$notify({
          type: 'error',
          message: this.$t('errors.code.fillInAllRequiredFields')
        })
      }

      return !hasErrors
    },

    save () {
      if (this.validateContactList()) {
        this.$emit('input', [...this.localData])
        this.showModal = false
      }
    },

    addContact () {
      this.localData = [...this.localData, {
        name: null,
        type: null,
        contact: null
      }]
      this.localDataErrors = []
    },

    removeItem (index) {
      this.localData.splice(index, 1)
      this.localDataErrors = []
    },

    onNameInput (index, e) {
      this.localData[index].name = e
      this.localDataErrors = []
    },

    onTypeInput (index, e) {
      this.localData[index].type = e
      this.localDataErrors = []
    },

    onContactInput (index, e) {
      this.localData[index].contact = e
      this.localDataErrors = []
    }
  },

  watch: {
    showModal (val) {
      if (!val) {
        this.localData = []
      } else {
        this.localData = this.value.map((el) => {
          return Object.assign({}, el)
        })
      }
    }
  }
}
</script>

<style lang="scss">
.add-shop-contact-list {
  &__options-block {
    &:last-child {
      margin-bottom: 2rem;
    }
  }

  &__options-item {

    &:not(:first-child) {
      padding-top: 2.5rem;
    }

    padding-bottom: 2.5rem;

    &:not(:last-child) {
      border-bottom: 1px solid $color-azure-light;
    }

    & > * {
      display: flex;
      flex-direction: column;

      @include respond(tab-port) {
        flex-direction: row;
        justify-content: space-between;
      }

      & > * {
        //margin-right: auto;
        width: 100%;

        &:not(:last-child) {
          margin-bottom: 1.2rem;
          margin-right: 1rem;
        }
      }

    }
  }
}
</style>
